import {Texts} from 'appearance'
import {useI18n} from 'store/Store'
import {CircularProgress, List, ListItem} from '@mui/material'
import FilmedDateForUploadItem from './FilmedDateForUploadItem'
import useUploadFilmedDatesForm from 'logic/Forms/useUploadFilmedDatesForm'

const FilesWaitingForUpload = () => {
    const {i18n} = useI18n()
    const {isFetching, filesForUpload} = useUploadFilmedDatesForm()

    return (
        <div>
            <Texts.Subtitle>
                {i18n.t('upload.filesWaitingForUpload')}
            </Texts.Subtitle>
            <List>
                {isFetching && <CircularProgress size={16} />}
                {filesForUpload && !filesForUpload.length ? (
                    <ListItem>{i18n.t('upload.noFiles')}</ListItem>
                ) : (
                    filesForUpload?.map((file) => (
                        <FilmedDateForUploadItem key={file.name} file={file} />
                    ))
                )}
            </List>
        </div>
    )
}

export default FilesWaitingForUpload
